import * as React from "react";
import { Alert } from "antd";
import { ErrorRenderer } from "./ErrorRenderer";
import { TaskError } from "../types";
import { observer } from "mobx-react-lite";

type Props = {
    errors: TaskError[];
    enrichmentStatus?: string;
    taskId: string;
};

export const TaskErrorsSection: React.FC<Props> = observer(
    ({ errors, enrichmentStatus, taskId }) => {
        const enrichmentFailed = enrichmentStatus === "Failed";
        return (
            <>
                {enrichmentFailed && (
                    <Alert
                        type="error"
                        showIcon
                        message="Metadata enrichment failed"
                        description={`Task context and Workbench linkage may be incomplete. Ask an administrator to review Enrichment Runs for task ${taskId}, check the failure and any scheduled retry, and retry or reprocess if needed.`}
                    />
                )}
                {!!errors.length && <ErrorRenderer errors={errors} />}
                {!errors.length && !enrichmentFailed && (
                    <div className="empty-message">There are no errors.</div>
                )}
            </>
        );
    },
);
